import type { OverrideAction } from './overrideActions';

export type OverrideFormDraft = {
  quantity: string;
  quantityAtOpen: string;
  action: OverrideAction | null;
  vendorId: string;
  sourceId: string;
};

export function createOverrideFormDraft(
  neededQuantity: number,
): OverrideFormDraft {
  const quantity = String(Math.round(neededQuantity));
  return {
    quantity,
    quantityAtOpen: quantity,
    action: null,
    vendorId: '',
    sourceId: '',
  };
}
